import { ChipFilter } from '@/pages/AdvancedEditor/components/panels/common/ChipFilter';
import { AvatarFilter } from '@/pages/avatar';

interface Props {
    filter: string;
    setFilter: (filter: string) => void;
    tagList: string[];
}

export const TemplatesTabs = ({ filter, setFilter, tagList }: Props) => {
    const handleTabChange = (id: string) => {
        setFilter(id as AvatarFilter);
    };

    const tabs = [
        {
            id: 'all',
            label: 'All',
            active: filter === 'all',
        },
        ...tagList.map(tag => ({
            id: tag,
            label: tag.charAt(0).toUpperCase() + tag.slice(1).replace(/-/g, ' '),
            active: filter === tag,
        })),
    ];

    return <ChipFilter tabs={tabs} maxWidth="392px" activeTab={filter} onTabChange={handleTabChange} />;
};
